import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Placeholder, Row, Tab, Table } from 'react-bootstrap';
import { IStatisticData } from '../dto/iStatistic';
import { StatisticsService } from '../StatisticsService';
import { calculatePercentage } from '../../../utils/helpers/CalculatePercentage';
import { ErrorToast } from '../../../utils/toasters';
import Flag from '../../../shared/components/Flag';
import TableSkeleton, { ITableColumn } from '../../../shared/components/TableSkeleton';
const STATISTICS_COLUMNS: ITableColumn[] = [
    { label: 'Country' },
    { label: 'Total' },
    { label: 'Total %' },
    { label: 'Male' },
    { label: 'Female' },
    { label: 'Other' },
];
export function Statistics() {
    const [statistics, setStatistics] = useState<IStatisticData>({
        totalInfluencer: '',
        totalBrand: '',
        statistic: [],
    });
    const [userType, setType] = useState('influencer');

    const [isLoading, setIsLoading] = useState(true);
    function TotalCount({ value }: { value: string | number }) {
        if (value === '' || value === undefined) {
            return (
                <Placeholder as="span" animation="glow">
                    <Placeholder className="skeleton" style={{ width: 30 }} />
                </Placeholder>
            );
        }
        return <>{value}</>;
    }
    useEffect(() => {
        let isCurrent = true;
        setIsLoading(true);

        StatisticsService.getStatistics(userType)
            .then(data => {
                if (isCurrent) setStatistics(data);
            })
            .catch(err => {
                if (isCurrent) ErrorToast(err);
            })
            .finally(() => {
                if (isCurrent) setIsLoading(false);
            });

        return () => {
            isCurrent = false;
        };
    }, [userType]);

    return (
        <Card className="mb-5 p-4 mt-3">
            <Tab.Container id="list-group-tabs" defaultActiveKey="#influencer">
                <Row>
                    <Col xs={6}>
                        <Button
                            size="lg"
                            className="w-100"
                            onClick={() => setType('influencer')}
                            variant={userType === 'influencer' ? 'primary' : 'outline-primary'}
                        >
                            Top countries for influencers (<TotalCount value={statistics?.totalInfluencer} />)
                        </Button>
                    </Col>
                    <Col xs={6}>
                        <Button
                            size="lg"
                            className="w-100"
                            onClick={() => setType('brand')}
                            variant={userType === 'brand' ? 'primary' : 'outline-primary'}
                        >
                            Top countries for brands (<TotalCount value={statistics?.totalBrand} />)
                        </Button>
                    </Col>
                </Row>
            </Tab.Container>
            {isLoading ? (
                <div className="mt-12">
                    <TableSkeleton columns={STATISTICS_COLUMNS} rows={10} />
                </div>
            ) : (
                <Table hover responsive className="mt-12">
                    <thead>
                        <tr>
                            {STATISTICS_COLUMNS.map(column => (
                                <th key={column.label}>{column.label}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {statistics.statistic.map(e => (
                            <tr key={e.country + '-' + e.count}>
                                <td>
                                    <Flag code={e?.country} />
                                </td>
                                <td>{e.count}</td>
                                <td>{e.percentage}%</td>
                                <td>
                                    {e.maleCount} ({calculatePercentage(+e.maleCount, +e.count)})%
                                </td>
                                <td>
                                    {e.femaleCount} ({calculatePercentage(+e.femaleCount, +e.count)})%
                                </td>
                                <td>
                                    {e.undefinedCount} ({calculatePercentage(+e.undefinedCount, +e.count)})%
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </Card>
    );
}
